export const CREATOR_EMAIL_RULES = {
  defaultDomain: "mail.artha.link",
  domainMaxLength: 189,
  domainPattern: /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z](?:[a-z0-9-]{0,61}[a-z0-9])?$/,
  usernamePattern: /^[a-z0-9]+(?:[_-][a-z0-9]+)*$/,
  localPartMaxLength: 64,
  defaultUsername: "creator",
  firstCollisionSuffix: 2,
  unsupportedCharactersPattern: /[^a-z0-9_-]+/g,
  repeatedSeparatorsPattern: /[_-]{2,}/g,
  edgeSeparatorsPattern: /^[_-]+|[_-]+$/g,
  reservedUsernames: new Set([
    "admin",
    "administrator",
    "support",
    "postmaster",
    "abuse",
    "security",
    "no-reply",
    "noreply",
    "no_reply",
    "mailer-daemon",
    "mailer_daemon",
    "artha",
    "artha-link",
    "artha_link",
    "artha-support",
    "artha_support",
    "artha-job-alerts",
    "artha_job_alerts",
    "billing",
    "help",
    "notifications",
    "notification",
    "job-alert",
    "job-alerts",
    "job_alerts",
    "jobs",
  ]),
} as const;
